import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.css'],
})
export class TextAreaComponent implements OnInit {

  @Input() controlForm: FormControl = new FormControl('');
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 300;
  @Input() whitePanel :boolean = false;

  get currentValue(): string {
    return this.controlForm.value || '';
  }

  constructor() { }

  ngOnInit(): void {
  }


}
